// Main is the content that varies depending on the type of page we're on.
// Page types are: project, workCollection, newsCollection, post, page

import React from "react";
import { Switch, Redirect, Route } from "react-router-dom";
import { startupFunctions, scrollToTop } from "../helpers";

import About from "./About";
import Contact from "./Contact";
import NewCollection from "./NewCollection";
import ProjectContent from "./ProjectContent";
import WorkCollection from "./WorkCollection";

const baseworkFetchURL = "https://wp.cghnyc.com/wp-json/cgh/";

class TheContent extends React.Component {
  constructor(props) {
    super(props);
    this.addPosts = this.addPosts.bind(this);
    this.addWork = this.addWork.bind(this);
    this.scrollToTop = scrollToTop.bind(this);
    this.setMaster = this.setMaster.bind(this);
    this.startupFunctions = startupFunctions.bind(this);
    this.updateActiveWorkSettings = this.updateActiveWorkSettings.bind(this);
    this.updateIfMobile = this.updateIfMobile.bind(this);
    this.updateMainClassesAndID = this.updateMainClassesAndID.bind(this);
    this.updatePageType = this.updatePageType.bind(this);

    // initial state with some default values
    this.state = {
      isMobile: false,
      loading: true,
      pageContent: "",
      pageType: null,
      pathname: this.props.location.pathname,
      posts: [],
      work: {
        activeCollection: null,
        activeType: null,
        checkerThumbs: false,
        collectionTitle: null,
        sortBy: "",
        theWork: {
          history: {
            all: [],
            "art-in-architecture": [],
            exhibits: [],
            graphics: [],
            logos: [],
          },
          modern: {
            all: [],
            "art-in-architecture": [],
            graphics: [],
            home: [],
            logos: [],
          },
        },
      },
    };
  }

  addPosts() {
    if (this.state.posts.length > 0) {
      return;
    }

    // the base url
    let postsFetchURL = `${baseworkFetchURL}posts/?total=-1`;

    // create a new promise for the work
    const postsPromise = fetch(postsFetchURL);

    postsPromise
      .then(data => data.json())
      .then(data => {
        let posts = [];

        data.map((k, i) => {
          return (posts[i] = k);
        });

        this.setState({ posts });
      })
      .catch(err => console.error(err));
  }

  addWork() {
    if (this.state.work.activeCollection === null || this.state.work.activeType === null) {
      return;
    }

    // If this category already has work, exit
    if (
      this.state.work.theWork[this.state.work.activeCollection][this.state.work.activeType].length >
      0
    ) {
      return;
    }

    this.scrollToTop();

    let newWorkState = { ...this.state.work };
    let workFetchURL = `${baseworkFetchURL}work/?total=-1`;

    this.updateActiveWorkSettings();

    // Is it history work or modern work?
    if (this.state.work.activeCollection === "history") {
      workFetchURL += "&history=true";
    }

    // what type is it? logo, graphic, or art in architecture?
    // the URLs will not always match the work keys, so we've got a switch here
    switch (this.state.work.activeType) {
      case "exhibits":
        workFetchURL += "&type=exhibit";
        break;

      case "logos":
        workFetchURL += "&type=logo";
        break;

      case "graphics":
        workFetchURL += "&type=graphic";
        break;

      case "art-in-architecture":
        workFetchURL += "&type=art-in-architecture";
        break;

      case "home":
        workFetchURL += `&home=true`;
        break;

      default:
        break;
    }

    if (this.state.work.sortBy) {
      workFetchURL += `&sort=${this.state.work.sortBy}`;
    }

    // create a new promise for the work
    const workPromise = fetch(workFetchURL);

    workPromise
      .then(data => data.json())
      .then(data => {
        let workToBeAdded = [];

        if (data.length === 0) {
          console.error("error: no work found");
          return;
        }

        data.map((k, i) => {
          return (workToBeAdded[i] = k);
        });

        newWorkState.theWork[this.state.work.activeCollection][this.state.work.activeType] =
          workToBeAdded;

        this.setState({ work: newWorkState });
      })
      .catch(err => console.error(err));
  }

  // To easily set TheContent states from children
  setMaster(prop, value) {
    if (typeof value === "object") {
      let stateObjectCopy = { ...this.state[prop] };
      let newStateObject = { ...stateObjectCopy, ...value };

      this.setState({ [prop]: newStateObject });
    } else {
      this.setState({ [prop]: value });
    }
  }

  updateActiveWorkSettings() {
    let newWorkState = { ...this.state.work };

    if (this.state.pageType === "workCollection" || this.state.pageType === null) {
      const currentPath = this.state.pathname;
      let activeType = "";
      let collectionTitle = null;

      if (this.state.pathname === "/" || this.state.pathname.match("^/work")) {
        newWorkState.activeCollection = "modern";
      } else {
        newWorkState.activeCollection = "history";
      }

      // Work type
      if (currentPath.match("architecture")) {
        activeType = "art-in-architecture";
        collectionTitle = "Art in Architecture";
      } else if (currentPath.match("exhibits")) {
        activeType = "exhibits";
        collectionTitle = "Exhibits";
      } else if (currentPath.match("graphics")) {
        activeType = "graphics";
        collectionTitle = "Graphics";
      } else if (currentPath.match("^/$")) {
        activeType = "home";
      } else if (currentPath.match("logos")) {
        activeType = "logos";
        collectionTitle = "Logos";
      } else {
        activeType = "all";
        collectionTitle = "History Work";
      }

      newWorkState.collectionTitle = collectionTitle;
      newWorkState.activeType = activeType;

      // Sort
      if (currentPath.match("/az")) {
        newWorkState.sortBy = "az";
      } else if (currentPath.match("/new")) {
        newWorkState.sortBy = "new";
      } else {
        newWorkState.sortBy = "curated";
      }
    }

    // Checking for checkering
    newWorkState.checkerThumbs =
      newWorkState.activeCollection === "modern" &&
      (newWorkState.activeType === "logos" || newWorkState.activeType === "home")
        ? true
        : false;

    // Update all
    this.setState({ work: newWorkState });
  }

  updateIfMobile() {
    let windowWidth = window.innerWidth;

    if (windowWidth < 640 && this.state.isMobile === false) {
      this.setState({ isMobile: true });
    } else if (windowWidth >= 640 && this.state.isMobile === true) {
      this.setState({ isMobile: false });
    }
  }

  updateMainClassesAndID() {
    const main = document.querySelector("main");

    // ID
    if (this.state.pathname === "/") {
      var pageID = "home";
    } else {
      let pathname = this.state.pathname;

      if (pathname.substr(pathname.length - 1) === "/") {
        pageID = this.state.pathname.slice(1, -1);
      } else {
        pageID = pathname;
      }
    }

    main.id = pageID;

    // Classes
    var mainClasses = [`pageType-${this.state.pageType}`];

    if (this.state.pageType !== "page") {
      mainClasses.push("main--loading");
    }

    main.className = mainClasses.join(" ");
  }

  updatePageType() {
    const pathname = this.state.pathname;

    if (pathname.match("(^/$|^/work/(logos|graphics|art-in-architecture)|^/history)")) {
      this.setState({ pageType: "workCollection" });
      this.updateActiveWorkSettings();
    } else if (pathname.match("(^/work/project)")) {
      this.setState({ pageType: "project" });
    } else if (pathname.match("^/new")) {
      this.setState({ pageType: "newCollection" });
    } else {
      this.setState({ pageType: "page" });
    }
  }

  componentWillMount() {
    this.startupFunctions();
    this.updatePageType();
    this.updateIfMobile();

    window.onresize = () => {
      this.updateIfMobile();
    };
  }

  componentDidMount() {
    this.updateMainClassesAndID();

    if (this.state.pageType === "workCollection") {
      this.addWork();
    } else if (this.state.pageType === "newCollection") {
      this.addPosts();
    }

    // The first load gets a longer fade time so we remove that class after
    // mounting for the first load
    if (this.state.pageType === ("workCollection" || "project")) {
      var waitForThumbnails = setInterval(() => {
        let workThumbnails = document.querySelector(".pageContent--workThumbnails");
        if (workThumbnails) {
          workThumbnails.classList.remove("js-firstLoad");
          clearInterval(waitForThumbnails);
        }
      }, 100);
    }
  }

  componentWillUpdate(nextProps, nextState) {
    // Update pathname when location changes
    if (this.props.location.pathname !== this.state.pathname) {
      this.setState({ pathname: this.props.location.pathname });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // page type changes
    if (this.state.pageType !== prevState.pageType) {
      this.scrollToTop();
      this.updateMainClassesAndID();

      if (
        prevState.pageType !== "workCollection" &&
        prevState.pageType !== "project" &&
        (this.state.pageType === "workCollection" || this.state.pageType === "project")
      ) {
        this.addWork();
      }

      if (this.state.pageType === "workCollection") {
        this.updateActiveWorkSettings();
      }
    }

    // Changed to new collection
    if (prevState.pageType !== "newCollection" && this.state.pageType === "newCollection") {
      this.addPosts();
    }

    // Pages with WorkCollection components on them
    if (this.state.pageType === "workCollection" || this.state.pageType === "project") {
      // workType changes from one real value to another
      if (
        prevState.work.activeType !== "" &&
        prevState.work.activeType !== this.state.work.activeType
      ) {
        this.addWork();
      }
    } // end Work Collection pages

    // pathname changes
    if (this.state.pathname !== prevState.pathname) {
      this.updateMainClassesAndID();
      this.updatePageType();
      this.scrollToTop();

      if (this.state.pageType === "workCollection" || this.state.pageType === "project") {
        this.addWork();
      }
    }

    // Change activeType to logos if on a project page and attempting to show home collection,
    // show all logos instead.
    if (this.state.pageType === "project" && this.state.work.activeType === "home") {
      this.setMaster("work", { activeType: "logos", collectionTitle: "Logos" });
    }
  } // componentDidUpdate

  render() {
    return (
      <main>
        <Switch>
          <Route
            exact
            path="/"
            render={({ match }) => (
              <WorkCollection
                activeWorkCollection={this.state.activeWorkCollection}
                pageType={this.state.pageType}
                setMaster={this.setMaster.bind(this)}
                sortBy={match.params.sortBy}
                work={this.state.work}
                workType={this.state.workType}
                homePage
              />
            )}
          />

          <Route
            exact
            path="/about/:bio?"
            render={({ match }) => (
              <About activeBio={match.params.bio} setMaster={this.setMaster.bind(this)} />
            )}
          />

          <Route
            exact
            path="/contact/"
            render={({ match }) => <Contact setMaster={this.setMaster.bind(this)} />}
          />

          <Route
            exact
            path="/new/"
            render={({ match }) => (
              <NewCollection posts={this.state.posts} setMaster={this.setMaster.bind(this)} />
            )}
          />

          <Route exact path="/work/">
            <Redirect to="/work/logos/" />
          </Route>

          <Route
            path="/work/project/:slug"
            render={({ match }) => (
              <ProjectContent
                activeWorkCollection={this.state.activeWorkCollection}
                isMobile={this.state.isMobile}
                pageType={this.state.pageType}
                params={match.params}
                setMaster={this.setMaster.bind(this)}
                slug={match.params.slug}
                work={this.state.work}
              />
            )}
          />

          <Route
            path="/work/:workType?/:sortBy?"
            render={({ match }) => (
              <WorkCollection
                activeWorkCollection={this.state.activeWorkCollection}
                pageType={this.state.pageType}
                params={match.params}
                pathname={this.state.pathname}
                setMaster={this.setMaster.bind(this)}
                work={this.state.work}
              />
            )}
          />

          <Route
            path="/history/:workType?/:sortBy?"
            render={({ match }) => (
              <WorkCollection
                activeWorkCollection={this.state.activeWorkCollection}
                pageType={this.state.pageType}
                params={match.params}
                pathname={this.state.pathname}
                setMaster={this.setMaster.bind(this)}
                work={this.state.work}
              />
            )}
          />

          <Redirect to="/" />
        </Switch>
      </main>
    );
  }
}

export default TheContent;



/** WEBPACK FOOTER **
 ** ./src/components/TheContent.js
 **/